// assign-to-group-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogActions } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProductGroupService } from '../../service/product-group.service';

@Component({
  selector: 'app-assign-to-group-dialog',
  standalone: true,
  templateUrl: './assign-to-group-dialog.component.html',
  styleUrls: ['./assign-to-group-dialog.component.scss'],
  providers: [ProductGroupService],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogActions,
    MatFormFieldModule
  ]
})
export class AssignToGroupDialogComponent {
  productIds: number[] = [];
  groupList: { id: string; name: string; selected: boolean }[] = [];

  constructor(
    public dialogRef: MatDialogRef<AssignToGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { productIds: number[] },
    private productGroupService: ProductGroupService,
    private snackBar: MatSnackBar
  ) {
    this.productIds = data.productIds;
  }

  async ngOnInit(): Promise<void> {
    const rawGroups = await this.productGroupService.getAllGroups();
    this.groupList = rawGroups.map(g => ({ ...g, selected: false }));
  }

  async onSubmit(): Promise<void> {
    const selectedGroupIds = this.groupList.filter(g => g.selected).map(g => g.id);
    if (selectedGroupIds.length === 0) return;
    await this.productGroupService.assignProductsToGroup(this.productIds, selectedGroupIds);
    this.snackBar.open('Products assigned to groups successfully!', 'Close', { duration: 3000 });
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}

